import React from "react";
import Dialog from "@mui/material/Dialog";
import { Form, Formik, FormikHelpers } from "formik";
import { object, string } from "yup";
import { showToast } from "src/utils/showToaster";
import SyllabusForm from "../Layouts/SyllabusForm";
import { SyllabusFormValues } from "src/models/Syllabus.model";
import { useAddSyllabusMutation } from "src/services/SyllabusService";

type Props = {
  onClose: () => void;
};

const AddSyllabusWrapper = ({ onClose }: Props) => {
  // Form Initial Values
  const initialValues: SyllabusFormValues = {
    syllabusName: "",
    order: "",
  };

  // Validation Schema
  const validationSchema = object().shape({
    syllabusName: string().required("Please enter Syllabus name"),
    order: string().required("Please enter order"),
  });

  const [addSyllabus] = useAddSyllabusMutation();

  // Handle Submit
  const handleSubmit = (
    values: SyllabusFormValues,
    { setSubmitting, resetForm }: FormikHelpers<SyllabusFormValues>
  ) => {
    const payload = {
      syllabusName: values.syllabusName,
      order:Number(values.order),
    };
    addSyllabus(payload).then((res: any) => {
      if (res?.error) {
        showToast("error", res?.error?.data?.message);
      } else {
        if (res?.data?.status) {
          showToast("success", res?.data?.message);
          resetForm();
          onClose();
        } else {
          showToast("error", res?.data?.message);
        }
      }
      setSubmitting(false);
    });
  };

  return (
    <Dialog open maxWidth="xs" fullWidth>
      <Formik
        initialValues={initialValues}
        validationSchema={validationSchema}
        onSubmit={handleSubmit}
      >
        {(formikProps) => (
          <Form>
            <SyllabusForm
              formikProps={formikProps}
              onClose={onClose}
              formType="ADD"
            />
          </Form>
        )}
      </Formik>
    </Dialog>
  );
};

export default AddSyllabusWrapper;
